module.exports = __webpack_public_path__ + "img/calendar-reserve.fc85c6bb.svg";